import React from 'react';
import './styles/app.scss';

import UseFetchPost from './components/shared/useFetchPost';
import {
  brandDirectoryPage,
  brandsAllFeed
} from './components/shared/jsonData';

// HOMEPAGE COMPONENTS
import BrandList from './components/BrandList';
import BrandsHero from './components/BrandsHero';

const App = () => {
  const getAllBrandsData = UseFetchPost(
    brandsAllFeed.endPointUrl,
    brandsAllFeed.endPointPrams
  );

  const getBrandDirectoryPage = UseFetchPost(
    brandDirectoryPage.endPointUrl,
    brandDirectoryPage.endPointPrams
  );

  if (getAllBrandsData && getAllBrandsData.hierarchy) {
    //console.log(getAllBrandsData.hierarchy);
    for (var key in getAllBrandsData.hierarchy) {
      var brand = getAllBrandsData.hierarchy[key];
      if (brand?.data?.total < 1) {
        delete getAllBrandsData.hierarchy[key];
        continue;
      }
    }
  }

  return (
    <section className="font-sans text-base font-base tracking-widest">
      <BrandsHero
        backgroundImg={
          getBrandDirectoryPage?.data
            ? getBrandDirectoryPage?.data.content.content[0].data
                .background_image
            : 'https://www.footasylum.com/images/src/seven/seven/wk31/hp_eos_sale_banner_final_60.jpg'
        }
        allBrandsData={getAllBrandsData}
      />

      <BrandList allBrandsData={getAllBrandsData} gaBlockName="Brands" />
    </section>
  );
};

export default App;
